import React, { useContext, useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    SimpleGrid,
    TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Heading,
    Select,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import { FaFilePdf, FaEdit } from 'react-icons/fa';
import axios from 'axios';
import CorsoModal from './CorsoModal';
import AuthContext from '../../contexts/AuthContext';

const DipendenteModal = ({ dipendente_id, retrieveDipendenti, isOpen, onClose }) => {
    const [dipendente, setDipendente] = useState(null);
    const [selectedCorso, setSelectedCorso] = useState(null);
    const [isCorsoModalOpen, setIsCorsoModalOpen] = useState(false);
    const {getToken} = useContext(AuthContext);
    const toast = useToast();

    useEffect(() => {
        console.log("Dipendente ID: " + dipendente_id);

        // Fetch the dipendente data based on the dipendente_id
        axios.get('/api/dipendenti/' + dipendente_id, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        }).then(response => {
            if(response.status === 200){
                setDipendente(response.data.dipendente);
            }else{
                console.error("Error fetching dipendente: " + response.data);
            }
        }).catch((error) => {
            console.error("Error fetching dipendente");
        });
    }, [dipendente_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.put(`/api/dipendenti/${dipendente_id}`, dipendente, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            });

            if (response.status === 200) {
                retrieveDipendenti(); // Refresh the list after creation
                toast({
                    title: "Successo",
                    description: "Dipendente aggiornato con successo.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
            } else {
                console.error("Error updating dipendente: " + response.data);
                toast({
                    title: "Errore",
                    description: "Si è verificato un errore durante l'aggiornamento del dipendente.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error("Error updating dipendente", error);
            toast({
                title: "Errore",
                description: "Si è verificato un errore durante l'aggiornamento del dipendente.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    }; 

    const getPdfCorso = async (corso) => {
        try {
            const response = await axios.get(`/api/dipendenti/corsi/${corso.id}/certificate`, {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${corso.nome}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("Error downloading PDF:", error);
        }
    }

    const handleEditCorso = (corso) => {
        setSelectedCorso(corso);
        setIsCorsoModalOpen(true);
    };

    const handleCorsoModalClose = () => {
        setIsCorsoModalOpen(false);
        setSelectedCorso(null);
    };

    // Puoi aggiungere qui la logica per salvare le modifiche al corso

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size='full'>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>Anagrafica dipendente</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {dipendente && (
                                <>
                                    <SimpleGrid columns={3} spacing={5} mb={5}>
                                        <FormControl id="name" isRequired>
                                            <FormLabel>Nome</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.name}
                                                onChange={(e) => setDipendente({ ...dipendente, name: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="surname" isRequired>
                                            <FormLabel>Cognome</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.surname}
                                                onChange={(e) => setDipendente({ ...dipendente, surname: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="birthdate" isRequired>
                                            <FormLabel>Data di nascita</FormLabel>
                                            <Input
                                                type="date"
                                                value={dipendente.birthdate}
                                                placeholder="YYYY-MM-DD"
                                                onChange={(e) => setDipendente({ ...dipendente, birthdate: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="hire_date" isRequired>
                                            <FormLabel>Data di assunzione</FormLabel>
                                            <Input
                                                type="date"
                                                value={dipendente.hire_date}
                                                placeholder="YYYY-MM-DD"
                                                onChange={(e) => setDipendente({ ...dipendente, hire_date: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="contract" isRequired>
                                            <FormLabel>Contratto</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.contract}
                                                onChange={(e) => setDipendente({ ...dipendente, contract: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="visita_medica" isRequired>
                                            <FormLabel>Visita medica</FormLabel>
                                            <Input
                                                type="date"
                                                value={dipendente.visita_medica}
                                                placeholder="YYYY-MM-DD"
                                                onChange={(e) => setDipendente({ ...dipendente, visita_medica: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="mansione" isRequired>
                                            <FormLabel>Mansione</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.mansione}
                                                onChange={(e) => setDipendente({ ...dipendente, mansione: e.target.value })}
                                            />
                                        </FormControl>

                                        <FormControl id="stipendio" isRequired>
                                            <FormLabel>Stipendio</FormLabel>
                                            <Input
                                                type="text"
                                                value={dipendente.stipendio}
                                                onChange={(e) => setDipendente({ ...dipendente, stipendio: e.target.value })}
                                            />
                                        </FormControl>
                                    </SimpleGrid>

                                    <Heading size="md" mb={2}>Corsi</Heading>
                                    <TableContainer>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th>Corso</Th>
                                                    <Th>Data di Rilascio</Th>
                                                    <Th>Scadenza</Th>
                                                    <Th>Ente</Th>
                                                    <Th>Ore</Th>
                                                    <Th></Th>
                                                    <Th></Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {dipendente.corsi.map((corso) => (
                                                    <Tr key={corso.id}>
                                                        <Td>{corso.nome}</Td>
                                                        <Td>{corso.data}</Td>
                                                        <Td>{corso.scadenza}</Td>
                                                        <Td>{corso.ente}</Td>
                                                        <Td>{corso.ore}</Td>
                                                        <Td>
                                                            {corso.pdf_certificato && (
                                                                <Button
                                                                    colorScheme="red"
                                                                    variant="ghost"
                                                                    onClick={() => getPdfCorso(corso)}
                                                                    leftIcon={<FaFilePdf />}
                                                                    title="Scarica Certificato"
                                                                />
                                                            )}
                                                        </Td>
                                                        <Td>
                                                            <Button
                                                                colorScheme="blue"
                                                                variant="ghost"
                                                                onClick={() => handleEditCorso(corso)}
                                                                leftIcon={<FaEdit />}
                                                                title="Modifica Corso"
                                                            />
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="teal" mr={3} type="submit">
                                Salva
                            </Button>
                            <Button variant="ghost" onClick={onClose}>
                                Annulla
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            {/* Modale per la modifica del corso */}
            <CorsoModal
                isOpen={isCorsoModalOpen}
                onClose={handleCorsoModalClose}
                corso={selectedCorso}
                onPdfDownload={getPdfCorso}
                // onSave={...} // Qui puoi passare la funzione per salvare le modifiche
                // onPdfDownload={...} // Qui puoi passare la funzione per scaricare il PDF
                // onPdfUpload={...} // Qui puoi passare la funzione per caricare il PDF
            />
        </>
    );
};

export default DipendenteModal;